import api from "@/utils/api";

// "Convert to sale": an open quotation (DRAFT / SENT / ACCEPTED) becomes a real invoice.
// DRAFT and SENT are first marked ACCEPTED (DRAFT -> SENT -> ACCEPTED, the only moves the server allows),
// then the invoice screen opens pre-filled from the quote; the invoice itself is created there with its own number.
export const CONVERTIBLE = ["DRAFT", "SENT", "ACCEPTED"];

export async function quoteToSale(quoteId, navigate) {
  let q = (await api.get(`/v2/quotations/${quoteId}`)).data;
  if (!CONVERTIBLE.includes(q.status)) throw new Error(`A ${q.status.toLowerCase()} quotation can't be converted. Clone it first.`);
  if (!q.customer_id) throw new Error("Link or create the customer first (see the yellow box on the quotation)");
  if (q.status === "DRAFT") q = (await api.post(`/v2/quotations/${quoteId}/status`, { status: "SENT" })).data;
  if (q.status === "SENT") q = (await api.post(`/v2/quotations/${quoteId}/status`, { status: "ACCEPTED" })).data;
  navigate("/admin/invoices/new", { state: { fromQuote: q } });
}

export const convertError = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : e?.message || "Could not convert to sale";
};
